export const GET_POKEMONS = 'GET_POKEMONS';
export const GET_POKEMONS_SUCCESS = 'GET_POKEMONS_SUCCESS';
export const GET_POKEMONS_ERROR = 'GET_POKEMONS_ERROR';

export const GET_POKEMON = 'GET_POKEMON';
export const GET_POKEMON_SUCCESS = 'GET_POKEMON_SUCCESS';
export const GET_POKEMON_ERROR = 'GET_POKEMON_ERROR';

export const ADD_OR_REMOVE_FAVORITE = 'ADD_OR_REMOVE_FAVORITE';
export const ADD_OR_REMOVE_FAVORITE_SUCCESS = 'ADD_OR_REMOVE_FAVORITE_SUCCESS';
export const ADD_OR_REMOVE_FAVORITE_ERROR = 'ADD_OR_REMOVE_FAVORITE_ERROR';

export const GET_FAVORITES = 'GET_FAVORITES';
export const GET_FAVORITES_SUCCESS = 'GET_FAVORITES_SUCCESS';
export const GET_FAVORITES_ERROR = 'GET_FAVORITES_ERROR';